import { Component, OnInit,ViewChild,TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup,FormArray , Validators } from '@angular/forms';
import {BasicService} from 'src/service/basic.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SmtpService } from 'src/service/smtp.service';
import { StatisticsService } from 'src/service/statistics.service';
import { InvoicesService } from 'src/service/invoices.service';
import { AuthService } from 'src/service/auth';

declare var require: any;
const Swal = require('sweetalert2');
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  name='';
  email='';
  apiKey='';
  role='';
  smtpForm:FormGroup;
  modalReference:any='';
  hideotp:boolean = false;
  disableSave=false;
  smtpId:any=0
  totalInvoiceUploaded:any=0
  totalInvoiceAccepted:any=0
  totalInvoiceRejected:any=0
  smtp_data:any={}
  passwordForm:FormGroup;
  invoiceForm:FormGroup;
  clipboardtext='';
  @ViewChild('changepwd') public changepwd: TemplateRef<any>;
  passwordSet:any=0
  showPassword: boolean = false;
  tooltiptext = "Copy to clipboard";
  showtooltip:boolean = false;

  constructor(private fb:FormBuilder,public basicService: BasicService, private authService: AuthService,private statisticsService:StatisticsService,private smtpService:SmtpService,private invoicesService:InvoicesService,private modalService: NgbModal) { 
    this.name=this.basicService.user_data.name
    this.role=this.basicService.user_data.roleName
    this.email=this.basicService.user_data.email
    this.apiKey=this.basicService.user_data.apiKey
    this.passwordSet=this.basicService.user_data.passwordSet
    this.clipboardtext = ""
    this.getSmtpDetailsByUserId()
    this.getStatisticsDetailsByBusinessId()
  }

  ngOnInit(): void {
  }
  onkeyPress=(event:any)=>{
    this.disableSave=true;
    this.hideotp = true;
    this.smtpForm.get('verificationCodeDigit1')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit1')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit2')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit2')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit3')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit3')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit4')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit4')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit5')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit5')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit6')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit6')!.updateValueAndValidity();
  }
  
  showInvoiceModal(modal:any){
    this.modalReference = this.modalService.open(modal, {size:'xl',centered: true, backdrop  : 'static',keyboard  : false,windowClass: 'animate__animated animate__flipInX' });  
    this.invoiceForm= this.fb.group({
      gstNum:[null,[Validators.required,this.basicService.isEmpty]],
      vendorName:[null,[Validators.required,this.basicService.isEmpty]],
      invoiceConfigDetails:this.fb.array([], [Validators.required])
    })     
  }
  showSMTPModal(modal:any){
    this.hideotp = true;
    this.disableSave=true;
    if(this.smtp_data.status){
      this.smtpForm= this.fb.group({
        host:[this.smtp_data.smtpHost,[Validators.required,this.basicService.isEmpty]],
        port:[this.smtp_data.smtpPort,[Validators.required,this.basicService.isEmpty]] ,    
        imaphost:[this.smtp_data.imtpHost,[Validators.required,this.basicService.isEmpty]],
        imapport:[this.smtp_data.imtpPort,[Validators.required,this.basicService.isEmpty]] ,          
        secure:[this.smtp_data.useSecuredConnection,[Validators.required]] ,      
        auth:[true,[Validators.required]] ,     
        login:[this.smtp_data.smtpEmail,[Validators.required,this.basicService.isEmpty]] , 
        password:[this.smtp_data.smtpPassword,[Validators.required,this.basicService.isEmpty]] ,            
        verificationCodeDigit1:[null,[]] ,            
        verificationCodeDigit2:[null,[]] ,            
        verificationCodeDigit3:[null,[]] ,            
        verificationCodeDigit4:[null,[]] ,            
        verificationCodeDigit5:[null,[]] ,            
        verificationCodeDigit6:[null,[]]                                         
      })  
    }else{
      this.smtpForm= this.fb.group({
        host:[null,[Validators.required,this.basicService.isEmpty]],
        port:[null,[Validators.required,this.basicService.isEmpty]] ,    
        imaphost:[null,[Validators.required,this.basicService.isEmpty]],
        imapport:[null,[Validators.required,this.basicService.isEmpty]] ,          
        secure:[false,[Validators.required]] ,      
        auth:[true,[Validators.required]] ,     
        login:[null,[Validators.required,this.basicService.isEmpty]] , 
        password:[null,[Validators.required,this.basicService.isEmpty]] ,            
        verificationCodeDigit1:[null,[]] ,            
        verificationCodeDigit2:[null,[]] ,            
        verificationCodeDigit3:[null,[]] ,            
        verificationCodeDigit4:[null,[]] ,            
        verificationCodeDigit5:[null,[]] ,            
        verificationCodeDigit6:[null,[]]                                         
      })  
    }
    this.modalReference = this.modalService.open(modal, {size:'md',centered: true, backdrop  : 'static',keyboard  : false,windowClass: 'animate__animated animate__flipInX' });  
    this.smtpForm.get('verificationCodeDigit1')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit1')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit2')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit2')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit3')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit3')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit4')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit4')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit5')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit5')!.updateValueAndValidity();
    this.smtpForm.get('verificationCodeDigit6')!.setValidators([]);
    this.smtpForm.get('verificationCodeDigit6')!.updateValueAndValidity();
  }
  showAPIKEYModal(modal:any){
    this.clipboardtext = "put api key here"
    this.modalService.open(modal, {size:'md',centered: true, backdrop  : 'static',keyboard  : false,windowClass: 'animate__animated animate__flipInX' });      
  }
  getSmtpDetailsByUserId(){
    let data={
      userId:this.basicService.user_data.id
    }
    this.basicService.showprogress=true;
    this.smtpService.getSmtpDetailsByUserId(data).toPromise().then((response: any) => {
      this.basicService.showprogress=false;
      if(response.status === "success"){
        this.smtp_data=response.smtp_data;
        
      } else{
        if(response.status === "failed"){
          this.smtp_data={}
          
        }          
      }
    });
  }
  testConnection(event:any){
    console.log(this.smtpForm.valid)
    if (this.smtpForm.valid) {
      let data={
        userId:this.basicService.user_data.id,
        smtpHost:this.smtpForm.controls["host"].value,
        smtpPort:this.smtpForm.controls["port"].value,
        imtpHost:this.smtpForm.controls["imaphost"].value,
        imtpPort:this.smtpForm.controls["imapport"].value,
        smtpEmail:this.smtpForm.controls["login"].value,
        smtpPassword:this.smtpForm.controls["password"].value,
        useSecuredConnection:this.smtpForm.controls["secure"].value
      }
      this.basicService.showprogress=true;
      this.smtpService.testSmtpConnection(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          Swal.fire('Success!', response.message, 'success').then((result:any) => {
            this.hideotp = false;
            this.disableSave=false;
            this.smtpId=response.id
            this.smtpForm.get('verificationCodeDigit1')!.setValidators([Validators.required,this.basicService.isEmpty]);
            this.smtpForm.get('verificationCodeDigit1')!.updateValueAndValidity();
            this.smtpForm.get('verificationCodeDigit2')!.setValidators([Validators.required,this.basicService.isEmpty]);
            this.smtpForm.get('verificationCodeDigit2')!.updateValueAndValidity();
            this.smtpForm.get('verificationCodeDigit3')!.setValidators([Validators.required,this.basicService.isEmpty]);
            this.smtpForm.get('verificationCodeDigit3')!.updateValueAndValidity();
            this.smtpForm.get('verificationCodeDigit4')!.setValidators([Validators.required,this.basicService.isEmpty]);
            this.smtpForm.get('verificationCodeDigit4')!.updateValueAndValidity();
            this.smtpForm.get('verificationCodeDigit5')!.setValidators([Validators.required,this.basicService.isEmpty]);
            this.smtpForm.get('verificationCodeDigit5')!.updateValueAndValidity();
            this.smtpForm.get('verificationCodeDigit6')!.setValidators([Validators.required,this.basicService.isEmpty]);
            this.smtpForm.get('verificationCodeDigit6')!.updateValueAndValidity();
          })
        } else{
          if(response.status === "failed"){
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.message,
                confirmButtonColor: '##0d6efd',
                showCancelButton: false,
                allowOutsideClick: true,
                confirmButtonText: 'Ok'
              }).then((result:any) => {
              });
          }          
        }
      });
      
    }else{
      for (const x in this.smtpForm.controls) {
        if (this.smtpForm.controls.hasOwnProperty(x)) {
            this.smtpForm.controls[x].markAsTouched()
        }
      }      
    }
  }
  saveConnection(event:any){
    if (this.smtpForm.valid) {
      let data={
        smtpId:this.smtpId,
        smtpOtp:this.smtpForm.controls["verificationCodeDigit1"].value+this.smtpForm.controls["verificationCodeDigit2"].value+this.smtpForm.controls["verificationCodeDigit3"].value+this.smtpForm.controls["verificationCodeDigit4"].value+this.smtpForm.controls["verificationCodeDigit5"].value+this.smtpForm.controls["verificationCodeDigit6"].value,
      }
      this.basicService.showprogress=true;
      this.smtpService.saveSmtpConnection(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          Swal.fire('Success!', response.message, 'success').then((result:any) => {
            this.modalReference.close()
            this.getSmtpDetailsByUserId()
          })
        } else{
          if(response.status === "failed"){
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.message,
                confirmButtonColor: '##0d6efd',
                showCancelButton: false,
                allowOutsideClick: true,
                confirmButtonText: 'Ok'
              }).then((result:any) => {
              });
          }          
        }
      });
      
    }else{
      for (const x in this.smtpForm.controls) {
        if (this.smtpForm.controls.hasOwnProperty(x)) {
            this.smtpForm.controls[x].markAsTouched()
        }
      }      
    }
  }

  
  getStatisticsDetailsByBusinessId(){
    let data={
      businessId:this.basicService.user_data.businessId
    }
    this.basicService.showprogress=true;
    this.statisticsService.getStatisticsByBusinessId(data).toPromise().then((response: any) => {
      if(response.status === "success"){
        this.basicService.showprogress=false;
        this.totalInvoiceUploaded=response.statistics_data['maxInvoices']-response.statistics_data['remainingInvoices']
        this.totalInvoiceAccepted=response.statistics_data['reviewedInvoices']
        this.totalInvoiceRejected=response.statistics_data['rejectedInvoices']
        
      } else{
        if(response.status === "failed"){
        }
      }
    });
  }
  openchangepwd(modal:any){
    this.modalService.open(modal, {centered: true, backdrop  : 'static',
    keyboard  : false,windowClass: 'animate__animated animate__flipInX' });
    this.passwordForm= this.fb.group({
      oldpwd:[null,[Validators.required,this.basicService.isEmpty]],
      newpwd:[null,[Validators.required,this.basicService.isEmpty]]      
    })  
    this.passwordForm= this.fb.group({
      oldpwd:[null,[Validators.required,this.basicService.isEmpty]],
      newpwd:[null,[Validators.required,this.basicService.isEmpty]]      
    })   
  } 
  onSubmitPassword = () =>{
    console.log(this.passwordForm.valid)
    if (this.passwordForm.valid) {
      let data={
        userId:this.basicService.user_data.id,
        oldPassword:this.passwordForm.controls["oldpwd"].value,
        newPassword:this.passwordForm.controls["newpwd"].value
      }
      this.basicService.showprogress=true;
      this.authService.changePassword(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          Swal.fire('Success!', 'Password reset successfully', 'success').then((result:any) => {
            this.basicService.user_data=response.user_data
            this.basicService.user_data.password=this.passwordForm.controls["newpwd"].value
            this.basicService.setItem("user_data",this.basicService.user_data);
            window.location.reload();
          })
        } else{
          if(response.status === "failure"){
            if(response.message == "Invalid old password"){

              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Incorrect Old Password',
                confirmButtonColor: '##0d6efd',
                showCancelButton: false,
                allowOutsideClick: true,
                confirmButtonText: 'Ok'
              }).then((result:any) => {

              });

            }
          }          
        }
      });  
    }
    else
    {
      for (const x in this.passwordForm.controls) {
        if (this.passwordForm.controls.hasOwnProperty(x)) {
            this.passwordForm.controls[x].markAsTouched()
        }
      }      
    }
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  onSMTPSubmit(){
    
  }
 
  copyapikeytoclipboard(){

    
    this.showtooltip = true;
    setTimeout( ()=> {
      this.showtooltip = false;
      
    }, 2500);
  }


  get invoiceConfigDetails(): FormArray {
    return this.invoiceForm.get('invoiceConfigDetails') as FormArray;
  }

  addRow(): void {
    this.invoiceConfigDetails.push(this.fb.group({"col_name":["",Validators.required],"alias_name":["",Validators.required],"rows":["",Validators.required],"cols":["",Validators.required],"row_in_col_pos":["",Validators.required],"col_in_row_pos":["",Validators.required]}));
  }

  getValidity(i:any) {
    return (<FormArray>this.invoiceForm.get('invoiceConfigDetails')).controls[i].invalid;
  }

  deleteRow(): void {
    this.invoiceConfigDetails.removeAt(this.invoiceConfigDetails.length-1);
    console.log(this.invoiceConfigDetails);
  }
  onInvoiceSubmit(){
    console.log(this.invoiceForm.valid)
    if (this.invoiceForm.valid) {
      let data={
        userId:this.basicService.user_data.id,
        gstNum:this.invoiceForm.controls["gstNum"].value,
        vendorName:this.invoiceForm.controls["vendorName"].value,
        invoiceConfigDetails:this.invoiceForm.controls["invoiceConfigDetails"].value
      }
      this.basicService.showprogress=true;
      this.invoicesService.saveInvoiceConfigDetails(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          Swal.fire('Success!', 'Config saved successfully', 'success').then((result:any) => {
          })
        }else{
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.message,
            confirmButtonColor: '##0d6efd',
            showCancelButton: false,
            allowOutsideClick: true,
            confirmButtonText: 'Ok'
          }).then((result:any) => {

          });
        }
      });
    }else{
      for (const x in this.invoiceForm.controls) {
        if (this.invoiceForm.controls.hasOwnProperty(x)) {
            this.invoiceForm.controls[x].markAsTouched()
            if(x=='invoiceConfigDetails'){
              for (let i=0;i<this.invoiceConfigDetails.controls.length;i++){
                let fg:any = this.invoiceConfigDetails.controls[i]
                for (const y in fg.controls) {
                  if (fg.controls.hasOwnProperty(y)) {
                    fg.controls[y].markAsTouched()
                  }
                }
              }
            }
        }
      }     
    }
  }

  validateConfig(){
    if(this.invoiceForm.controls["gstNum"].value!=''){
      let data={
        userId:this.basicService.user_data.id,
        gstNum:this.invoiceForm.controls["gstNum"].value
      }
      this.invoiceForm.patchValue({
        invoiceConfigDetails: [],
        vendorName:''
      });
      let count=this.invoiceConfigDetails.length
      for(let i=0;i<count;i++){
        this.deleteRow()
      }
      this.basicService.showprogress=true;
      this.invoicesService.validateInvoiceConfigDetails(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          let configDetails=response.config_data.invoiceConfigDetails;
          this.invoiceForm.patchValue({
            vendorName:response.config_data.vendorName
          });
          for(let i=0;i<configDetails.length;i++){
            this.invoiceConfigDetails.push(this.fb.group({
              "col_name":[configDetails[i]['col_name'],Validators.required],
              "alias_name":[configDetails[i]['alias_name'],Validators.required],
              "rows":[configDetails[i]['rows'],Validators.required],
              "cols":[configDetails[i]['cols'],Validators.required],
              "row_in_col_pos":[configDetails[i]['row_in_col_pos'],Validators.required],
              "col_in_row_pos":[configDetails[i]['col_in_row_pos'],Validators.required]
            }));
          }
        }else{
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.message,
            confirmButtonColor: '##0d6efd',
            showCancelButton: false,
            allowOutsideClick: true,
            confirmButtonText: 'Ok'
          }).then((result:any) => {

          });
        }
      });
    }else{
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'GST number is empty',
        confirmButtonColor: '##0d6efd',
        showCancelButton: false,
        allowOutsideClick: true,
        confirmButtonText: 'Ok'
      }).then((result:any) => {

      });
    }
    
  }
}
